import { render, staticRenderFns } from "./PackageResultItem.vue?vue&type=template&id=1da557ad&"
import script from "./PackageResultItem.vue?vue&type=script&lang=js&"
export * from "./PackageResultItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageResultItem.vue?vue&type=style&index=0&id=1da557ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports